import { render, staticRenderFns } from "./BarChartStatistic.vue?vue&type=template&id=3fddf09a"
import script from "./BarChartStatistic.vue?vue&type=script&lang=js"
export * from "./BarChartStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports